export default __webpack_public_path__ + "static/media/userImg.7df29dbb.jpg";